import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { AuthenticationService } from '@auth-services/authentication.service';
import {MenuResponseModel} from '@global-models/Response/MenuResponseModel'

declare let mLayout: any;

@Component({
  selector: 'app-aside-nav',
  templateUrl: './aside-nav.component.html',
  encapsulation: ViewEncapsulation.None
})

export class AsideNavComponent implements OnInit, AfterViewInit {
  public menuresults: Array<MenuResponseModel>;

  constructor(private _authService: AuthenticationService) { }

  ngOnInit() {
    this.fillAsideMenu();
  }

  fillAsideMenu() {
    this.menuresults = (JSON.parse(localStorage.getItem('DashboardMenus')) as Array<MenuResponseModel>);

    if (this.menuresults === null && this.menuresults === undefined) {
      this.menuresults = new Array<MenuResponseModel>();
      this._authService.logout();
    }
  }

  ngAfterViewInit() {
    mLayout.initAside();
  }
}
